
function toggleTabView($element, locationHash) {
    const $tabs = [...$element];
    const $match = locationHash ? $tabs.find($tab => $tab.getAttribute('href') === locationHash) : null;

    $tabs.forEach(item => item.addEventListener('click', event => {
        event.preventDefault();
        handleClick(event.currentTarget);
    }));

    function handleClick(target) {
        const clickedTab = target.hash;

        $tabs.forEach(tab => {
            const hrefAttribute = tab.getAttribute('href');
            const contentContainer = document.querySelector(hrefAttribute);

            if(hrefAttribute === clickedTab){
                tab.classList.add('selected');
                contentContainer.style.display = 'block';
            }else{
                tab.classList.remove('selected');
                contentContainer.style.display = 'none';
            }
        });
    }

    if ($match) {
        handleClick($match);
        return;
    }

    if ($element.length) {
        handleClick($element[0]);
    }
}


export default toggleTabView;